import { authService } from '@/features/auth/auth.service'
import { meToAuthUser } from '@/lib/auth-user'
import { useAuthStore } from '@/stores/auth-store'

let inflight: Promise<void> | null = null

/** Hydrate user from /v1/me once per page load (dedupes parallel callers). */
export function ensureAuthUser(): Promise<void> {
  const { user, setUser, getEffectiveAccessToken } = useAuthStore.getState().auth
  if (!getEffectiveAccessToken() || user) {
    return Promise.resolve()
  }

  if (!inflight) {
    inflight = (async () => {
      try {
        const me = await authService.getCurrentUser()
        setUser(meToAuthUser(me))
      } catch {
        // Token invalid — leave user null; route guards handle redirect.
      } finally {
        inflight = null
      }
    })()
  }

  return inflight
}
